import React from "react";
import Switch from "react-switch";

type Props = {
  settingName?: string;
  settingDescription?: string;
  state: boolean;
  onText?: string;
  offText?: string;
  labeled?: boolean;
  onToggle: () => void;
};

export const ToggleSetting: React.FC<Props> = props => (
  <div>
    {props.settingName ? (
      <span style={{ display: "block", marginBottom: ".25rem" }}>{props.settingName}</span>
    ) : (
      ""
    )}
    <div>
      <Switch
        onChange={props.onToggle}
        checked={props.state}
        uncheckedIcon={false}
        checkedIcon={false}
        height={20}
        width={40}
      />
      {props.labeled ? (
        <span style={{ position: "relative", top: "-4px", paddingLeft: "5px" }}>
          {!!props.onText && props.state ? props.onText : ""}
          {!!props.offText && !props.state ? props.offText : ""}
        </span>
      ) : (
        ""
      )}
    </div>
    {props.settingDescription ? (
      <small style={{ display: "block" }}>{props.settingDescription}</small>
    ) : (
      ""
    )}
  </div>
);

ToggleSetting.defaultProps = {
  onText: "On",
  offText: "Off",
  labeled: false
};
